import { DeleteRecordedVideos, DeleteUploadedVideos, GetChannelVideos, GetRecordedVideos } from '../../../connection/videos';
import { AsyncAction, Action } from '../../../types/actions';
import { UploadJob } from '../../reducers/admin/videos';

export const GET_CHANNEL_UP_VIDEOS = "GET_CHANNEL_UP_VIDEOS";
export function getChannelUpVideos(token: string, channel: number): AsyncAction {
	return {
		type: GET_CHANNEL_UP_VIDEOS,
		promise: GetChannelVideos(token, channel)
	};
}

export const CREATE_UPLOAD_JOB = "CREATE_UPLOAD_JOB";
export function createUploadJob(callback: (e: any) => void, onStarted?: (e: any) => void): Action {
	return {
		type: CREATE_UPLOAD_JOB,
		payload: { callback, onStarted }
	};
}

export const UPDATE_UPLOAD_JOB = "UPDATE_UPLOAD_JOB";
export function updateUploadJob(job: UploadJob): Action {
	return {
		type: UPDATE_UPLOAD_JOB,
		payload: job
	};
}

export const FINISH_UPLOAD_JOB = "FINISH_UPLOAD_JOB";
export function finishUploadJob(uuid: string): Action {
	return {
		type: FINISH_UPLOAD_JOB,
		payload: uuid
	};
}

export const GET_CHANNEL_RECORDINGS = "_GET_CHANNEL_RECORDINGS";
export function getChannelRecordings(token: string, channel: number): AsyncAction {
	return {
		type: GET_CHANNEL_RECORDINGS,
		promise: GetRecordedVideos(token, channel)
	};
}

export const DELETE_RECORDED_VIDEOS = 'DELETE_RECORDED_VIDEOS';
export function deleteRecordedVideo(videoIDs: number[], token: string, channel: number): AsyncAction {
	return {
		type: DELETE_RECORDED_VIDEOS,
		promise: DeleteRecordedVideos(videoIDs, token, channel)
	};
}

export const DELETE_UPLOADED_VIDEOS = 'DELETE_UPLOADED_VIDEOS';
export function deleteUploadedVideo(videoIDs: number[], token: string, channel: number): AsyncAction {
	return {
		type: DELETE_UPLOADED_VIDEOS,
		promise: DeleteUploadedVideos(videoIDs, token, channel)
	};
}

export const CLEAR_DELETE_VIDEO_ERROR = "CLEAR_DELETE_VIDEO_ERROR";
export function clearDeleteVideoError(): Action {
	return {
		type: CLEAR_DELETE_VIDEO_ERROR,
		payload: ""
	};
}
